"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectVersions = exports.projectGroupStatuses = exports.projectPaymentModes = exports.projectMigrationStatuses = exports.projectStatuses = void 0;
exports.projectStatuses = ['ACTIVE', 'INACTIVE', 'COMPLETED', 'ARCHIVED'];
/** HOT→COLD data migration lifecycle for an ARCHIVED project. */
exports.projectMigrationStatuses = ['NOT_MIGRATED', 'MIGRATING', 'MIGRATED', 'FAILED'];
exports.projectPaymentModes = ['TASK', 'PROJECT'];
exports.projectGroupStatuses = ['ACTIVE', 'INACTIVE'];
exports.projectVersions = ['V1', 'V2'];
//# sourceMappingURL=Projects.js.map